module.exports = __webpack_public_path__ + "assets-cabinet/img/support-icon-black.f93d8ec4.svg";